(() => {
  if (window.loopsDiscoveryQuestion) return;
  const attribute = 'Where did you first hear about Loops Only?';
  const selector = '[data-loops-discovery]';
  const initial = document.querySelector(`${selector} input:checked`) || document.querySelector('#loops-discovery-template')?.content.querySelector('input:checked');
  const state = { value: initial?.value, pending: Promise.resolve(), busy: false };
  window.loopsDiscoveryQuestion = state;

  function mountDrawer() {
    const button = document.querySelector('#kaching-cart__checkout-button');
    const template = document.querySelector('#loops-discovery-template');
    if (!button || !template || button.parentElement.querySelector(selector)) return;
    const fragment = template.content.cloneNode(true);
    button.before(fragment);
  }

  function sync() {
    if (state.value === undefined) return;
    document.querySelectorAll(`${selector} input[type="radio"]`).forEach((input) => {
      input.checked = input.value === state.value;
    });
  }

  function save(fieldset, value) {
    state.value = value;
    sync();
    state.busy = true;
    const pending = state.pending.then(async () => {
      const response = await fetch(fieldset.dataset.updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [attribute]: value } }),
        keepalive: true,
      });
      if (!response.ok) throw new Error('Cart attribute update failed');
    }).catch(() => {});
    state.pending = pending;
    pending.finally(() => {
      if (state.pending === pending) state.busy = false;
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const fieldset = input.closest(selector);
    if (!fieldset) return;
    save(fieldset, input.value);
  });

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest?.('#kaching-cart__checkout-button');
    if (checkout && state.busy) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const finish = () => {
        if (state.busy) return state.pending.then(finish);
        if (checkout.isConnected) checkout.click();
      };
      state.pending.then(finish);
      return;
    }
    const button = event.target.closest?.('[data-loops-discovery-clear]');
    if (!button) return;
    const fieldset = button.closest(selector);
    save(fieldset, '');
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const fieldset = [...document.querySelectorAll(selector)].find((el) => el.querySelector('input')?.form === form);
    if (!fieldset || !state.busy) return;
    event.preventDefault();
    const submitter = event.submitter;
    const finish = () => {
      if (state.busy) return state.pending.then(finish);
      if (form.isConnected) form.requestSubmit(submitter?.isConnected ? submitter : undefined);
    };
    state.pending.then(finish);
  }, true);

  const observer = new MutationObserver(() => {
    mountDrawer();
    sync();
  });
  mountDrawer();
  sync();
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
